import * as React from 'react'
import {AppContextProvider} from "./src/components/context/app-context";
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'
import 'gatsby-plugin-prismic-previews/dist/styles.css'

export const wrapRootElement = ({ element }) => (
    <AppContextProvider>
        <PrismicPreviewProvider>
            {element}
        </PrismicPreviewProvider>
    </AppContextProvider>

)